import request from "@/utils/request.js";
import {
  handlerGetUrlParams
} from "@/utils/dealUrlParams.js";

export function getEssayList(params) {
  const url = handlerGetUrlParams("bus/article/list", params);
  return request({
    url,
    method: "POST",
    data: params
  });
}

export function getModuleList() {
  return request({
    url: 'bus/article/article_menu',
    method: "GET",
  });
}

export function increasedEssay(data) {
  return request({
    url: 'bus/article',
    method: "POST",
    data
  });
}
export function addArticle(data) {
  return request({
    url: 'bus/article',
    method: "PUT",
    data
  });
}
export function detailArticle(id) {
  return request({
    url: 'bus/article/'+id,
    method: "GET"
  });
}
// 编辑
export function editStatus(data) {
  return request({
    url: '/bus/article/edit_status',
    method: "PUT",
    data
  });
}
// 删除或恢复文章
export function editExisted(data) {
  return request({
    url: '/bus/article/edit_existed',
    method: "PUT",
    data
  });
}
// 销毁
export function deleteExisted(data) {
  return request({
    url: '/bus/article/'+data.id,
    method: "DELETE",
  });
}
